import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Nav from "../components/Nav";
import { api } from "../lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let active = true;
    const poll = async (n) => {
      if (!active) return;
      if (n > 8) { setState("pending"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        setAttempts(n);
        setTimeout(() => poll(n + 1), 2000);
      } catch { setState("error"); }
    };
    poll(0);
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div className="bg-[#050505] min-h-screen"><Nav />
      <div className="max-w-2xl mx-auto px-5 pt-52 pb-40 text-center" data-testid="payment-success">
        {state === "checking" && <><Loader2 size={48} className="animate-spin text-[var(--accent)] mx-auto" /><p className="font-mono text-sm uppercase tracking-widest text-[var(--text-secondary)] mt-6">Confirming your payment… ({attempts})</p></>}
        {state === "paid" && <><CheckCircle2 size={56} className="text-[var(--accent)] mx-auto" /><h1 className="font-display text-5xl font-black uppercase tracking-tighter mt-6">Payment confirmed</h1><p className="text-[var(--text-secondary)] mt-4">Thanks for your purchase. We'll be in touch about pickup or delivery.</p></>}
        {state === "pending" && <><Loader2 size={48} className="animate-spin text-[var(--accent)] mx-auto" /><h1 className="font-display text-3xl font-black uppercase mt-6">Still processing</h1><p className="text-[var(--text-secondary)] mt-4">Your payment is taking a moment. You'll get a confirmation shortly.</p></>}
        {state === "error" && <><XCircle size={56} className="text-[var(--accent)] mx-auto" /><h1 className="font-display text-3xl font-black uppercase mt-6">Couldn't verify</h1><p className="text-[var(--text-secondary)] mt-4">We couldn't confirm this session. If you were charged, contact us.</p></>}
        <Link to="/marketplace" className="inline-block mt-10 border border-[var(--border-dim)] hover:border-white px-8 py-4 font-mono text-sm uppercase tracking-widest transition-colors">Back to marketplace</Link>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="bg-[#050505] min-h-screen"><Nav />
      <div className="max-w-2xl mx-auto px-5 pt-52 pb-40 text-center" data-testid="payment-cancel">
        <XCircle size={56} className="text-[var(--text-secondary)] mx-auto" />
        <h1 className="font-display text-5xl font-black uppercase tracking-tighter mt-6">Checkout canceled</h1>
        <p className="text-[var(--text-secondary)] mt-4">No charge was made. The item is still available if you change your mind.</p>
        <Link to="/marketplace" className="inline-block mt-10 btn-wipe bg-[var(--accent)] text-white hover:text-white px-8 py-4 font-mono text-sm uppercase tracking-widest font-bold">Back to marketplace</Link>
      </div>
    </div>
  );
}
